<template>
  <!-- begin:: Footer -->
  <div
    class="mt-n8 div-footer footer py-4 d-flex flex-lg-column"
    id="kt_footer"
  >
    <div
      class="div-footer d-flex align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="text-dark">
        <span class="text-muted font-weight-bold mr-2">
          {{ $store.getters.footerMessageLabel }}
        </span>
        <a
          :href="$store.getters.footerLink"
          target="_blank"
          class="text-dark-75 text-hover-primary"
        >
          {{ $store.getters.footerMessage }}
        </a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'KTFooter',
  computed: {
    ...mapGetters(['layoutConfig']),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig('footer.width') === 'fluid';
    },
  },
};
</script>
<style scoped>
.div-footer {
  max-height: 20px;
}
</style>
